/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as CustomDomainTestRouteImport } from './routes/custom-domain-test'
import { Route as GoogleoauthRouteImport } from './routes/googleoauth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as MicrosoftoauthRouteImport } from './routes/microsoftoauth'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SlackoauthRouteImport } from './routes/slackoauth'
import { Route as SsoLoginRouteImport } from './routes/sso-login'
import { Route as SsoSignupRouteImport } from './routes/sso-signup'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as AuthenticatedShellRouteImport } from './routes/_authenticated/_shell'
import { Route as AuthenticatedInviteDelegateRouteImport } from './routes/_authenticated/invite-delegate'
import { Route as BookDemoIndexRouteImport } from './routes/book-demo.index'
import { Route as BookDemoSignUpRouteImport } from './routes/book-demo.sign-up'
import { Route as McpConsentRouteImport } from './routes/mcp.consent'
import { Route as SsoCallbackRouteImport } from './routes/sso.callback'
import { Route as ZoomCallbackRouteImport } from './routes/zoom.callback'
import { Route as AuthenticatedShellIndexRouteImport } from './routes/_authenticated/_shell/index'
import { Route as AuthenticatedShellSplatRouteImport } from './routes/_authenticated/_shell/$'
import { Route as AuthenticatedShellOwnAccountRouteImport } from './routes/_authenticated/_shell/_ownAccount'
import { Route as AuthenticatedShellAccountRouteImport } from './routes/_authenticated/_shell/account'
import { Route as AuthenticatedShellAdminRouteImport } from './routes/_authenticated/_shell/admin'
import { Route as AuthenticatedShellAvailabilityRouteImport } from './routes/_authenticated/_shell/availability'
import { Route as AuthenticatedShellBetaRouteImport } from './routes/_authenticated/_shell/beta'
import { Route as AuthenticatedShellBillingRouteImport } from './routes/_authenticated/_shell/billing'
import { Route as AuthenticatedShellChatRouteImport } from './routes/_authenticated/_shell/chat'
import { Route as AuthenticatedShellContactsRouteImport } from './routes/_authenticated/_shell/contacts'
import { Route as AuthenticatedShellMemoriesRouteImport } from './routes/_authenticated/_shell/memories'
import { Route as AuthenticatedShellNotificationsRouteImport } from './routes/_authenticated/_shell/notifications'
import { Route as AuthenticatedShellPersonalChatRouteImport } from './routes/_authenticated/_shell/personal-chat'
import { Route as AuthenticatedShellPlacesRouteImport } from './routes/_authenticated/_shell/places'
import { Route as AuthenticatedShellPreferencesRouteImport } from './routes/_authenticated/_shell/preferences'
import { Route as AuthenticatedShellRecurringRouteImport } from './routes/_authenticated/_shell/recurring'
import { Route as AuthenticatedOnboardingSplatRouteImport } from './routes/_authenticated/onboarding.$'
import { Route as AuthenticatedShellOwnAccountActivityRouteImport } from './routes/_authenticated/_shell/_ownAccount/activity'
import { Route as AuthenticatedShellOwnAccountIntegrationsRouteImport } from './routes/_authenticated/_shell/_ownAccount/integrations'
import { Route as AuthenticatedShellAdminIndexRouteImport } from './routes/_authenticated/_shell/admin/index'
import { Route as AuthenticatedShellAdminZoomRolloutRouteImport } from './routes/_authenticated/_shell/admin/_zoomRollout'
import { Route as AuthenticatedShellAdminGroupsRouteImport } from './routes/_authenticated/_shell/admin/groups'
import { Route as AuthenticatedShellAdminMembersRouteImport } from './routes/_authenticated/_shell/admin/members'
import { Route as AuthenticatedShellAdminSettingsRouteImport } from './routes/_authenticated/_shell/admin/settings'
import { Route as AuthenticatedShellAdminUsageRouteImport } from './routes/_authenticated/_shell/admin/usage'
import { Route as AuthenticatedShellChatIdRouteImport } from './routes/_authenticated/_shell/chat.$id'
import { Route as AuthenticatedShellTemplatesIndexRouteImport } from './routes/_authenticated/_shell/templates.index'
import { Route as LinkNamespaceLinkIdChar123MeetingIdChar125RouteImport } from './routes/link.$namespace.$linkId.{-$meetingId}'
import { Route as AuthenticatedShellAdminGroupsGroupIdRouteImport } from './routes/_authenticated/_shell/admin/groups.$groupId'
import { Route as AuthenticatedShellTemplatesIdEditRouteImport } from './routes/_authenticated/_shell/templates.$id.edit'
import { Route as AuthenticatedShellAdminZoomRolloutZoomCallbackRouteImport } from './routes/_authenticated/_shell/admin/_zoomRollout/zoom.callback'
import { Route as AuthenticatedShellAdminZoomRolloutZoomUsersRouteImport } from './routes/_authenticated/_shell/admin/_zoomRollout/zoom.users'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomDomainTestRoute = CustomDomainTestRouteImport.update({
  id: '/custom-domain-test',
  path: '/custom-domain-test',
  getParentRoute: () => rootRouteImport,
} as any)
const GoogleoauthRoute = GoogleoauthRouteImport.update({
  id: '/googleoauth',
  path: '/googleoauth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const MicrosoftoauthRoute = MicrosoftoauthRouteImport.update({
  id: '/microsoftoauth',
  path: '/microsoftoauth',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SlackoauthRoute = SlackoauthRouteImport.update({
  id: '/slackoauth',
  path: '/slackoauth',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoLoginRoute = SsoLoginRouteImport.update({
  id: '/sso-login',
  path: '/sso-login',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoSignupRoute = SsoSignupRouteImport.update({
  id: '/sso-signup',
  path: '/sso-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellRoute = AuthenticatedShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInviteDelegateRoute =
  AuthenticatedInviteDelegateRouteImport.update({
    id: '/invite-delegate',
    path: '/invite-delegate',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const BookDemoIndexRoute = BookDemoIndexRouteImport.update({
  id: '/book-demo/',
  path: '/book-demo/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookDemoSignUpRoute = BookDemoSignUpRouteImport.update({
  id: '/book-demo/sign-up',
  path: '/book-demo/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const McpConsentRoute = McpConsentRouteImport.update({
  id: '/mcp/consent',
  path: '/mcp/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso/callback',
  path: '/sso/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ZoomCallbackRoute = ZoomCallbackRouteImport.update({
  id: '/zoom/callback',
  path: '/zoom/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedShellIndexRoute = AuthenticatedShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellSplatRoute = AuthenticatedShellSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellOwnAccountRoute =
  AuthenticatedShellOwnAccountRouteImport.update({
    id: '/_ownAccount',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellAccountRoute =
  AuthenticatedShellAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellAdminRoute = AuthenticatedShellAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellAvailabilityRoute =
  AuthenticatedShellAvailabilityRouteImport.update({
    id: '/availability',
    path: '/availability',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellBetaRoute = AuthenticatedShellBetaRouteImport.update({
  id: '/beta',
  path: '/beta',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellBillingRoute =
  AuthenticatedShellBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellChatRoute = AuthenticatedShellChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedShellRoute,
} as any)
const AuthenticatedShellContactsRoute =
  AuthenticatedShellContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellMemoriesRoute =
  AuthenticatedShellMemoriesRouteImport.update({
    id: '/memories',
    path: '/memories',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellNotificationsRoute =
  AuthenticatedShellNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPersonalChatRoute =
  AuthenticatedShellPersonalChatRouteImport.update({
    id: '/personal-chat',
    path: '/personal-chat',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPlacesRoute =
  AuthenticatedShellPlacesRouteImport.update({
    id: '/places',
    path: '/places',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellPreferencesRoute =
  AuthenticatedShellPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellRecurringRoute =
  AuthenticatedShellRecurringRouteImport.update({
    id: '/recurring',
    path: '/recurring',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedOnboardingSplatRoute =
  AuthenticatedOnboardingSplatRouteImport.update({
    id: '/onboarding/$',
    path: '/onboarding/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShellOwnAccountActivityRoute =
  AuthenticatedShellOwnAccountActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedShellOwnAccountRoute,
  } as any)
const AuthenticatedShellOwnAccountIntegrationsRoute =
  AuthenticatedShellOwnAccountIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedShellOwnAccountRoute,
  } as any)
const AuthenticatedShellAdminIndexRoute =
  AuthenticatedShellAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedShellAdminRoute,
  } as any)
const AuthenticatedShellAdminZoomRolloutRoute =
  AuthenticatedShellAdminZoomRolloutRouteImport.update({
    id: '/_zoomRollout',
    getParentRoute: () => AuthenticatedShellAdminRoute,
  } as any)
const AuthenticatedShellAdminGroupsRoute =
  AuthenticatedShellAdminGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedShellAdminRoute,
  } as any)
const AuthenticatedShellAdminMembersRoute =
  AuthenticatedShellAdminMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedShellAdminRoute,
  } as any)
const AuthenticatedShellAdminSettingsRoute =
  AuthenticatedShellAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedShellAdminRoute,
  } as any)
const AuthenticatedShellAdminUsageRoute =
  AuthenticatedShellAdminUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedShellAdminRoute,
  } as any)
const AuthenticatedShellChatIdRoute =
  AuthenticatedShellChatIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedShellChatRoute,
  } as any)
const AuthenticatedShellTemplatesIndexRoute =
  AuthenticatedShellTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const LinkNamespaceLinkIdChar123MeetingIdChar125Route =
  LinkNamespaceLinkIdChar123MeetingIdChar125RouteImport.update({
    id: '/link/$namespace/$linkId/{-$meetingId}',
    path: '/link/$namespace/$linkId/{-$meetingId}',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedShellAdminGroupsGroupIdRoute =
  AuthenticatedShellAdminGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AuthenticatedShellAdminGroupsRoute,
  } as any)
const AuthenticatedShellTemplatesIdEditRoute =
  AuthenticatedShellTemplatesIdEditRouteImport.update({
    id: '/templates/$id/edit',
    path: '/templates/$id/edit',
    getParentRoute: () => AuthenticatedShellRoute,
  } as any)
const AuthenticatedShellAdminZoomRolloutZoomCallbackRoute =
  AuthenticatedShellAdminZoomRolloutZoomCallbackRouteImport.update({
    id: '/zoom/callback',
    path: '/zoom/callback',
    getParentRoute: () => AuthenticatedShellAdminZoomRolloutRoute,
  } as any)
const AuthenticatedShellAdminZoomRolloutZoomUsersRoute =
  AuthenticatedShellAdminZoomRolloutZoomUsersRouteImport.update({
    id: '/zoom/users',
    path: '/zoom/users',
    getParentRoute: () => AuthenticatedShellAdminZoomRolloutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedShellIndexRoute
  '/custom-domain-test': typeof CustomDomainTestRoute
  '/googleoauth': typeof GoogleoauthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/microsoftoauth': typeof MicrosoftoauthRoute
  '/signup': typeof SignupRoute
  '/slackoauth': typeof SlackoauthRoute
  '/sso-login': typeof SsoLoginRoute
  '/sso-signup': typeof SsoSignupRoute
  '/waitlist': typeof WaitlistRoute
  '/invite-delegate': typeof AuthenticatedInviteDelegateRoute
  '/book-demo/sign-up': typeof BookDemoSignUpRoute
  '/mcp/consent': typeof McpConsentRoute
  '/sso/callback': typeof SsoCallbackRoute
  '/zoom/callback': typeof ZoomCallbackRoute
  '/book-demo/': typeof BookDemoIndexRoute
  '/$': typeof AuthenticatedShellSplatRoute
  '/account': typeof AuthenticatedShellAccountRoute
  '/admin': typeof AuthenticatedShellAdminRouteWithChildren
  '/availability': typeof AuthenticatedShellAvailabilityRoute
  '/beta': typeof AuthenticatedShellBetaRoute
  '/billing': typeof AuthenticatedShellBillingRoute
  '/chat': typeof AuthenticatedShellChatRouteWithChildren
  '/contacts': typeof AuthenticatedShellContactsRoute
  '/memories': typeof AuthenticatedShellMemoriesRoute
  '/notifications': typeof AuthenticatedShellNotificationsRoute
  '/personal-chat': typeof AuthenticatedShellPersonalChatRoute
  '/places': typeof AuthenticatedShellPlacesRoute
  '/preferences': typeof AuthenticatedShellPreferencesRoute
  '/recurring': typeof AuthenticatedShellRecurringRoute
  '/onboarding/$': typeof AuthenticatedOnboardingSplatRoute
  '/activity': typeof AuthenticatedShellOwnAccountActivityRoute
  '/integrations': typeof AuthenticatedShellOwnAccountIntegrationsRoute
  '/admin/groups': typeof AuthenticatedShellAdminGroupsRouteWithChildren
  '/admin/members': typeof AuthenticatedShellAdminMembersRoute
  '/admin/settings': typeof AuthenticatedShellAdminSettingsRoute
  '/admin/usage': typeof AuthenticatedShellAdminUsageRoute
  '/chat/$id': typeof AuthenticatedShellChatIdRoute
  '/link/$namespace/$linkId/{-$meetingId}': typeof LinkNamespaceLinkIdChar123MeetingIdChar125Route
  '/admin/': typeof AuthenticatedShellAdminIndexRoute
  '/templates/': typeof AuthenticatedShellTemplatesIndexRoute
  '/admin/groups/$groupId': typeof AuthenticatedShellAdminGroupsGroupIdRoute
  '/templates/$id/edit': typeof AuthenticatedShellTemplatesIdEditRoute
  '/admin/zoom/callback': typeof AuthenticatedShellAdminZoomRolloutZoomCallbackRoute
  '/admin/zoom/users': typeof AuthenticatedShellAdminZoomRolloutZoomUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedShellIndexRoute
  '/custom-domain-test': typeof CustomDomainTestRoute
  '/googleoauth': typeof GoogleoauthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/microsoftoauth': typeof MicrosoftoauthRoute
  '/signup': typeof SignupRoute
  '/slackoauth': typeof SlackoauthRoute
  '/sso-login': typeof SsoLoginRoute
  '/sso-signup': typeof SsoSignupRoute
  '/waitlist': typeof WaitlistRoute
  '/invite-delegate': typeof AuthenticatedInviteDelegateRoute
  '/book-demo/sign-up': typeof BookDemoSignUpRoute
  '/mcp/consent': typeof McpConsentRoute
  '/sso/callback': typeof SsoCallbackRoute
  '/zoom/callback': typeof ZoomCallbackRoute
  '/book-demo': typeof BookDemoIndexRoute
  '/$': typeof AuthenticatedShellSplatRoute
  '/account': typeof AuthenticatedShellAccountRoute
  '/availability': typeof AuthenticatedShellAvailabilityRoute
  '/beta': typeof AuthenticatedShellBetaRoute
  '/billing': typeof AuthenticatedShellBillingRoute
  '/chat': typeof AuthenticatedShellChatRouteWithChildren
  '/contacts': typeof AuthenticatedShellContactsRoute
  '/memories': typeof AuthenticatedShellMemoriesRoute
  '/notifications': typeof AuthenticatedShellNotificationsRoute
  '/personal-chat': typeof AuthenticatedShellPersonalChatRoute
  '/places': typeof AuthenticatedShellPlacesRoute
  '/preferences': typeof AuthenticatedShellPreferencesRoute
  '/recurring': typeof AuthenticatedShellRecurringRoute
  '/onboarding/$': typeof AuthenticatedOnboardingSplatRoute
  '/activity': typeof AuthenticatedShellOwnAccountActivityRoute
  '/integrations': typeof AuthenticatedShellOwnAccountIntegrationsRoute
  '/admin': typeof AuthenticatedShellAdminIndexRoute
  '/admin/groups': typeof AuthenticatedShellAdminGroupsRouteWithChildren
  '/admin/members': typeof AuthenticatedShellAdminMembersRoute
  '/admin/settings': typeof AuthenticatedShellAdminSettingsRoute
  '/admin/usage': typeof AuthenticatedShellAdminUsageRoute
  '/chat/$id': typeof AuthenticatedShellChatIdRoute
  '/link/$namespace/$linkId/{-$meetingId}': typeof LinkNamespaceLinkIdChar123MeetingIdChar125Route
  '/templates': typeof AuthenticatedShellTemplatesIndexRoute
  '/admin/groups/$groupId': typeof AuthenticatedShellAdminGroupsGroupIdRoute
  '/templates/$id/edit': typeof AuthenticatedShellTemplatesIdEditRoute
  '/admin/zoom/callback': typeof AuthenticatedShellAdminZoomRolloutZoomCallbackRoute
  '/admin/zoom/users': typeof AuthenticatedShellAdminZoomRolloutZoomUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/custom-domain-test': typeof CustomDomainTestRoute
  '/googleoauth': typeof GoogleoauthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/microsoftoauth': typeof MicrosoftoauthRoute
  '/signup': typeof SignupRoute
  '/slackoauth': typeof SlackoauthRoute
  '/sso-login': typeof SsoLoginRoute
  '/sso-signup': typeof SsoSignupRoute
  '/waitlist': typeof WaitlistRoute
  '/_authenticated/_shell': typeof AuthenticatedShellRouteWithChildren
  '/_authenticated/invite-delegate': typeof AuthenticatedInviteDelegateRoute
  '/book-demo/sign-up': typeof BookDemoSignUpRoute
  '/mcp/consent': typeof McpConsentRoute
  '/sso/callback': typeof SsoCallbackRoute
  '/zoom/callback': typeof ZoomCallbackRoute
  '/book-demo/': typeof BookDemoIndexRoute
  '/_authenticated/_shell/$': typeof AuthenticatedShellSplatRoute
  '/_authenticated/_shell/_ownAccount': typeof AuthenticatedShellOwnAccountRouteWithChildren
  '/_authenticated/_shell/account': typeof AuthenticatedShellAccountRoute
  '/_authenticated/_shell/admin': typeof AuthenticatedShellAdminRouteWithChildren
  '/_authenticated/_shell/availability': typeof AuthenticatedShellAvailabilityRoute
  '/_authenticated/_shell/beta': typeof AuthenticatedShellBetaRoute
  '/_authenticated/_shell/billing': typeof AuthenticatedShellBillingRoute
  '/_authenticated/_shell/chat': typeof AuthenticatedShellChatRouteWithChildren
  '/_authenticated/_shell/contacts': typeof AuthenticatedShellContactsRoute
  '/_authenticated/_shell/memories': typeof AuthenticatedShellMemoriesRoute
  '/_authenticated/_shell/notifications': typeof AuthenticatedShellNotificationsRoute
  '/_authenticated/_shell/personal-chat': typeof AuthenticatedShellPersonalChatRoute
  '/_authenticated/_shell/places': typeof AuthenticatedShellPlacesRoute
  '/_authenticated/_shell/preferences': typeof AuthenticatedShellPreferencesRoute
  '/_authenticated/_shell/recurring': typeof AuthenticatedShellRecurringRoute
  '/_authenticated/onboarding/$': typeof AuthenticatedOnboardingSplatRoute
  '/_authenticated/_shell/': typeof AuthenticatedShellIndexRoute
  '/_authenticated/_shell/_ownAccount/activity': typeof AuthenticatedShellOwnAccountActivityRoute
  '/_authenticated/_shell/_ownAccount/integrations': typeof AuthenticatedShellOwnAccountIntegrationsRoute
  '/_authenticated/_shell/admin/_zoomRollout': typeof AuthenticatedShellAdminZoomRolloutRouteWithChildren
  '/_authenticated/_shell/admin/groups': typeof AuthenticatedShellAdminGroupsRouteWithChildren
  '/_authenticated/_shell/admin/members': typeof AuthenticatedShellAdminMembersRoute
  '/_authenticated/_shell/admin/settings': typeof AuthenticatedShellAdminSettingsRoute
  '/_authenticated/_shell/admin/usage': typeof AuthenticatedShellAdminUsageRoute
  '/_authenticated/_shell/chat/$id': typeof AuthenticatedShellChatIdRoute
  '/link/$namespace/$linkId/{-$meetingId}': typeof LinkNamespaceLinkIdChar123MeetingIdChar125Route
  '/_authenticated/_shell/admin/': typeof AuthenticatedShellAdminIndexRoute
  '/_authenticated/_shell/templates/': typeof AuthenticatedShellTemplatesIndexRoute
  '/_authenticated/_shell/admin/groups/$groupId': typeof AuthenticatedShellAdminGroupsGroupIdRoute
  '/_authenticated/_shell/templates/$id/edit': typeof AuthenticatedShellTemplatesIdEditRoute
  '/_authenticated/_shell/admin/_zoomRollout/zoom/callback': typeof AuthenticatedShellAdminZoomRolloutZoomCallbackRoute
  '/_authenticated/_shell/admin/_zoomRollout/zoom/users': typeof AuthenticatedShellAdminZoomRolloutZoomUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/custom-domain-test'
    | '/googleoauth'
    | '/login'
    | '/logout'
    | '/microsoftoauth'
    | '/signup'
    | '/slackoauth'
    | '/sso-login'
    | '/sso-signup'
    | '/waitlist'
    | '/invite-delegate'
    | '/book-demo/sign-up'
    | '/mcp/consent'
    | '/sso/callback'
    | '/zoom/callback'
    | '/book-demo/'
    | '/$'
    | '/account'
    | '/admin'
    | '/availability'
    | '/beta'
    | '/billing'
    | '/chat'
    | '/contacts'
    | '/memories'
    | '/notifications'
    | '/personal-chat'
    | '/places'
    | '/preferences'
    | '/recurring'
    | '/onboarding/$'
    | '/activity'
    | '/integrations'
    | '/admin/groups'
    | '/admin/members'
    | '/admin/settings'
    | '/admin/usage'
    | '/chat/$id'
    | '/link/$namespace/$linkId/{-$meetingId}'
    | '/admin/'
    | '/templates/'
    | '/admin/groups/$groupId'
    | '/templates/$id/edit'
    | '/admin/zoom/callback'
    | '/admin/zoom/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/custom-domain-test'
    | '/googleoauth'
    | '/login'
    | '/logout'
    | '/microsoftoauth'
    | '/signup'
    | '/slackoauth'
    | '/sso-login'
    | '/sso-signup'
    | '/waitlist'
    | '/invite-delegate'
    | '/book-demo/sign-up'
    | '/mcp/consent'
    | '/sso/callback'
    | '/zoom/callback'
    | '/book-demo'
    | '/$'
    | '/account'
    | '/availability'
    | '/beta'
    | '/billing'
    | '/chat'
    | '/contacts'
    | '/memories'
    | '/notifications'
    | '/personal-chat'
    | '/places'
    | '/preferences'
    | '/recurring'
    | '/onboarding/$'
    | '/activity'
    | '/integrations'
    | '/admin'
    | '/admin/groups'
    | '/admin/members'
    | '/admin/settings'
    | '/admin/usage'
    | '/chat/$id'
    | '/link/$namespace/$linkId/{-$meetingId}'
    | '/templates'
    | '/admin/groups/$groupId'
    | '/templates/$id/edit'
    | '/admin/zoom/callback'
    | '/admin/zoom/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/custom-domain-test'
    | '/googleoauth'
    | '/login'
    | '/logout'
    | '/microsoftoauth'
    | '/signup'
    | '/slackoauth'
    | '/sso-login'
    | '/sso-signup'
    | '/waitlist'
    | '/_authenticated/_shell'
    | '/_authenticated/invite-delegate'
    | '/book-demo/sign-up'
    | '/mcp/consent'
    | '/sso/callback'
    | '/zoom/callback'
    | '/book-demo/'
    | '/_authenticated/_shell/$'
    | '/_authenticated/_shell/_ownAccount'
    | '/_authenticated/_shell/account'
    | '/_authenticated/_shell/admin'
    | '/_authenticated/_shell/availability'
    | '/_authenticated/_shell/beta'
    | '/_authenticated/_shell/billing'
    | '/_authenticated/_shell/chat'
    | '/_authenticated/_shell/contacts'
    | '/_authenticated/_shell/memories'
    | '/_authenticated/_shell/notifications'
    | '/_authenticated/_shell/personal-chat'
    | '/_authenticated/_shell/places'
    | '/_authenticated/_shell/preferences'
    | '/_authenticated/_shell/recurring'
    | '/_authenticated/onboarding/$'
    | '/_authenticated/_shell/'
    | '/_authenticated/_shell/_ownAccount/activity'
    | '/_authenticated/_shell/_ownAccount/integrations'
    | '/_authenticated/_shell/admin/_zoomRollout'
    | '/_authenticated/_shell/admin/groups'
    | '/_authenticated/_shell/admin/members'
    | '/_authenticated/_shell/admin/settings'
    | '/_authenticated/_shell/admin/usage'
    | '/_authenticated/_shell/chat/$id'
    | '/link/$namespace/$linkId/{-$meetingId}'
    | '/_authenticated/_shell/admin/'
    | '/_authenticated/_shell/templates/'
    | '/_authenticated/_shell/admin/groups/$groupId'
    | '/_authenticated/_shell/templates/$id/edit'
    | '/_authenticated/_shell/admin/_zoomRollout/zoom/callback'
    | '/_authenticated/_shell/admin/_zoomRollout/zoom/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CustomDomainTestRoute: typeof CustomDomainTestRoute
  GoogleoauthRoute: typeof GoogleoauthRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  MicrosoftoauthRoute: typeof MicrosoftoauthRoute
  SignupRoute: typeof SignupRoute
  SlackoauthRoute: typeof SlackoauthRoute
  SsoLoginRoute: typeof SsoLoginRoute
  SsoSignupRoute: typeof SsoSignupRoute
  WaitlistRoute: typeof WaitlistRoute
  BookDemoSignUpRoute: typeof BookDemoSignUpRoute
  McpConsentRoute: typeof McpConsentRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  ZoomCallbackRoute: typeof ZoomCallbackRoute
  BookDemoIndexRoute: typeof BookDemoIndexRoute
  LinkNamespaceLinkIdChar123MeetingIdChar125Route: typeof LinkNamespaceLinkIdChar123MeetingIdChar125Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom-domain-test': {
      id: '/custom-domain-test'
      path: '/custom-domain-test'
      fullPath: '/custom-domain-test'
      preLoaderRoute: typeof CustomDomainTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/googleoauth': {
      id: '/googleoauth'
      path: '/googleoauth'
      fullPath: '/googleoauth'
      preLoaderRoute: typeof GoogleoauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/microsoftoauth': {
      id: '/microsoftoauth'
      path: '/microsoftoauth'
      fullPath: '/microsoftoauth'
      preLoaderRoute: typeof MicrosoftoauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slackoauth': {
      id: '/slackoauth'
      path: '/slackoauth'
      fullPath: '/slackoauth'
      preLoaderRoute: typeof SlackoauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-login': {
      id: '/sso-login'
      path: '/sso-login'
      fullPath: '/sso-login'
      preLoaderRoute: typeof SsoLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-signup': {
      id: '/sso-signup'
      path: '/sso-signup'
      fullPath: '/sso-signup'
      preLoaderRoute: typeof SsoSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell': {
      id: '/_authenticated/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invite-delegate': {
      id: '/_authenticated/invite-delegate'
      path: '/invite-delegate'
      fullPath: '/invite-delegate'
      preLoaderRoute: typeof AuthenticatedInviteDelegateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/book-demo/': {
      id: '/book-demo/'
      path: '/book-demo'
      fullPath: '/book-demo/'
      preLoaderRoute: typeof BookDemoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book-demo/sign-up': {
      id: '/book-demo/sign-up'
      path: '/book-demo/sign-up'
      fullPath: '/book-demo/sign-up'
      preLoaderRoute: typeof BookDemoSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp/consent': {
      id: '/mcp/consent'
      path: '/mcp/consent'
      fullPath: '/mcp/consent'
      preLoaderRoute: typeof McpConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/callback': {
      id: '/sso/callback'
      path: '/sso/callback'
      fullPath: '/sso/callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zoom/callback': {
      id: '/zoom/callback'
      path: '/zoom/callback'
      fullPath: '/zoom/callback'
      preLoaderRoute: typeof ZoomCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell/': {
      id: '/_authenticated/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellIndexRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/$': {
      id: '/_authenticated/_shell/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedShellSplatRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/_ownAccount': {
      id: '/_authenticated/_shell/_ownAccount'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedShellOwnAccountRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/account': {
      id: '/_authenticated/_shell/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedShellAccountRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/admin': {
      id: '/_authenticated/_shell/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedShellAdminRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/availability': {
      id: '/_authenticated/_shell/availability'
      path: '/availability'
      fullPath: '/availability'
      preLoaderRoute: typeof AuthenticatedShellAvailabilityRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/beta': {
      id: '/_authenticated/_shell/beta'
      path: '/beta'
      fullPath: '/beta'
      preLoaderRoute: typeof AuthenticatedShellBetaRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/billing': {
      id: '/_authenticated/_shell/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedShellBillingRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/chat': {
      id: '/_authenticated/_shell/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedShellChatRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/contacts': {
      id: '/_authenticated/_shell/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedShellContactsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/memories': {
      id: '/_authenticated/_shell/memories'
      path: '/memories'
      fullPath: '/memories'
      preLoaderRoute: typeof AuthenticatedShellMemoriesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/notifications': {
      id: '/_authenticated/_shell/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedShellNotificationsRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/personal-chat': {
      id: '/_authenticated/_shell/personal-chat'
      path: '/personal-chat'
      fullPath: '/personal-chat'
      preLoaderRoute: typeof AuthenticatedShellPersonalChatRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/places': {
      id: '/_authenticated/_shell/places'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof AuthenticatedShellPlacesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/preferences': {
      id: '/_authenticated/_shell/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof AuthenticatedShellPreferencesRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/recurring': {
      id: '/_authenticated/_shell/recurring'
      path: '/recurring'
      fullPath: '/recurring'
      preLoaderRoute: typeof AuthenticatedShellRecurringRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/onboarding/$': {
      id: '/_authenticated/onboarding/$'
      path: '/onboarding/$'
      fullPath: '/onboarding/$'
      preLoaderRoute: typeof AuthenticatedOnboardingSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_shell/_ownAccount/activity': {
      id: '/_authenticated/_shell/_ownAccount/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedShellOwnAccountActivityRouteImport
      parentRoute: typeof AuthenticatedShellOwnAccountRoute
    }
    '/_authenticated/_shell/_ownAccount/integrations': {
      id: '/_authenticated/_shell/_ownAccount/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedShellOwnAccountIntegrationsRouteImport
      parentRoute: typeof AuthenticatedShellOwnAccountRoute
    }
    '/_authenticated/_shell/admin/': {
      id: '/_authenticated/_shell/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedShellAdminIndexRouteImport
      parentRoute: typeof AuthenticatedShellAdminRoute
    }
    '/_authenticated/_shell/admin/_zoomRollout': {
      id: '/_authenticated/_shell/admin/_zoomRollout'
      path: ''
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedShellAdminZoomRolloutRouteImport
      parentRoute: typeof AuthenticatedShellAdminRoute
    }
    '/_authenticated/_shell/admin/groups': {
      id: '/_authenticated/_shell/admin/groups'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof AuthenticatedShellAdminGroupsRouteImport
      parentRoute: typeof AuthenticatedShellAdminRoute
    }
    '/_authenticated/_shell/admin/members': {
      id: '/_authenticated/_shell/admin/members'
      path: '/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof AuthenticatedShellAdminMembersRouteImport
      parentRoute: typeof AuthenticatedShellAdminRoute
    }
    '/_authenticated/_shell/admin/settings': {
      id: '/_authenticated/_shell/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedShellAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedShellAdminRoute
    }
    '/_authenticated/_shell/admin/usage': {
      id: '/_authenticated/_shell/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AuthenticatedShellAdminUsageRouteImport
      parentRoute: typeof AuthenticatedShellAdminRoute
    }
    '/_authenticated/_shell/chat/$id': {
      id: '/_authenticated/_shell/chat/$id'
      path: '/$id'
      fullPath: '/chat/$id'
      preLoaderRoute: typeof AuthenticatedShellChatIdRouteImport
      parentRoute: typeof AuthenticatedShellChatRoute
    }
    '/_authenticated/_shell/templates/': {
      id: '/_authenticated/_shell/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthenticatedShellTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/link/$namespace/$linkId/{-$meetingId}': {
      id: '/link/$namespace/$linkId/{-$meetingId}'
      path: '/link/$namespace/$linkId/{-$meetingId}'
      fullPath: '/link/$namespace/$linkId/{-$meetingId}'
      preLoaderRoute: typeof LinkNamespaceLinkIdChar123MeetingIdChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_shell/admin/groups/$groupId': {
      id: '/_authenticated/_shell/admin/groups/$groupId'
      path: '/$groupId'
      fullPath: '/admin/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedShellAdminGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedShellAdminGroupsRoute
    }
    '/_authenticated/_shell/templates/$id/edit': {
      id: '/_authenticated/_shell/templates/$id/edit'
      path: '/templates/$id/edit'
      fullPath: '/templates/$id/edit'
      preLoaderRoute: typeof AuthenticatedShellTemplatesIdEditRouteImport
      parentRoute: typeof AuthenticatedShellRoute
    }
    '/_authenticated/_shell/admin/_zoomRollout/zoom/callback': {
      id: '/_authenticated/_shell/admin/_zoomRollout/zoom/callback'
      path: '/zoom/callback'
      fullPath: '/admin/zoom/callback'
      preLoaderRoute: typeof AuthenticatedShellAdminZoomRolloutZoomCallbackRouteImport
      parentRoute: typeof AuthenticatedShellAdminZoomRolloutRoute
    }
    '/_authenticated/_shell/admin/_zoomRollout/zoom/users': {
      id: '/_authenticated/_shell/admin/_zoomRollout/zoom/users'
      path: '/zoom/users'
      fullPath: '/admin/zoom/users'
      preLoaderRoute: typeof AuthenticatedShellAdminZoomRolloutZoomUsersRouteImport
      parentRoute: typeof AuthenticatedShellAdminZoomRolloutRoute
    }
  }
}

interface AuthenticatedShellOwnAccountRouteChildren {
  AuthenticatedShellOwnAccountActivityRoute: typeof AuthenticatedShellOwnAccountActivityRoute
  AuthenticatedShellOwnAccountIntegrationsRoute: typeof AuthenticatedShellOwnAccountIntegrationsRoute
}

const AuthenticatedShellOwnAccountRouteChildren: AuthenticatedShellOwnAccountRouteChildren =
  {
    AuthenticatedShellOwnAccountActivityRoute:
      AuthenticatedShellOwnAccountActivityRoute,
    AuthenticatedShellOwnAccountIntegrationsRoute:
      AuthenticatedShellOwnAccountIntegrationsRoute,
  }

const AuthenticatedShellOwnAccountRouteWithChildren =
  AuthenticatedShellOwnAccountRoute._addFileChildren(
    AuthenticatedShellOwnAccountRouteChildren,
  )

interface AuthenticatedShellAdminZoomRolloutRouteChildren {
  AuthenticatedShellAdminZoomRolloutZoomCallbackRoute: typeof AuthenticatedShellAdminZoomRolloutZoomCallbackRoute
  AuthenticatedShellAdminZoomRolloutZoomUsersRoute: typeof AuthenticatedShellAdminZoomRolloutZoomUsersRoute
}

const AuthenticatedShellAdminZoomRolloutRouteChildren: AuthenticatedShellAdminZoomRolloutRouteChildren =
  {
    AuthenticatedShellAdminZoomRolloutZoomCallbackRoute:
      AuthenticatedShellAdminZoomRolloutZoomCallbackRoute,
    AuthenticatedShellAdminZoomRolloutZoomUsersRoute:
      AuthenticatedShellAdminZoomRolloutZoomUsersRoute,
  }

const AuthenticatedShellAdminZoomRolloutRouteWithChildren =
  AuthenticatedShellAdminZoomRolloutRoute._addFileChildren(
    AuthenticatedShellAdminZoomRolloutRouteChildren,
  )

interface AuthenticatedShellAdminGroupsRouteChildren {
  AuthenticatedShellAdminGroupsGroupIdRoute: typeof AuthenticatedShellAdminGroupsGroupIdRoute
}

const AuthenticatedShellAdminGroupsRouteChildren: AuthenticatedShellAdminGroupsRouteChildren =
  {
    AuthenticatedShellAdminGroupsGroupIdRoute:
      AuthenticatedShellAdminGroupsGroupIdRoute,
  }

const AuthenticatedShellAdminGroupsRouteWithChildren =
  AuthenticatedShellAdminGroupsRoute._addFileChildren(
    AuthenticatedShellAdminGroupsRouteChildren,
  )

interface AuthenticatedShellAdminRouteChildren {
  AuthenticatedShellAdminZoomRolloutRoute: typeof AuthenticatedShellAdminZoomRolloutRouteWithChildren
  AuthenticatedShellAdminGroupsRoute: typeof AuthenticatedShellAdminGroupsRouteWithChildren
  AuthenticatedShellAdminMembersRoute: typeof AuthenticatedShellAdminMembersRoute
  AuthenticatedShellAdminSettingsRoute: typeof AuthenticatedShellAdminSettingsRoute
  AuthenticatedShellAdminUsageRoute: typeof AuthenticatedShellAdminUsageRoute
  AuthenticatedShellAdminIndexRoute: typeof AuthenticatedShellAdminIndexRoute
}

const AuthenticatedShellAdminRouteChildren: AuthenticatedShellAdminRouteChildren =
  {
    AuthenticatedShellAdminZoomRolloutRoute:
      AuthenticatedShellAdminZoomRolloutRouteWithChildren,
    AuthenticatedShellAdminGroupsRoute:
      AuthenticatedShellAdminGroupsRouteWithChildren,
    AuthenticatedShellAdminMembersRoute: AuthenticatedShellAdminMembersRoute,
    AuthenticatedShellAdminSettingsRoute: AuthenticatedShellAdminSettingsRoute,
    AuthenticatedShellAdminUsageRoute: AuthenticatedShellAdminUsageRoute,
    AuthenticatedShellAdminIndexRoute: AuthenticatedShellAdminIndexRoute,
  }

const AuthenticatedShellAdminRouteWithChildren =
  AuthenticatedShellAdminRoute._addFileChildren(
    AuthenticatedShellAdminRouteChildren,
  )

interface AuthenticatedShellChatRouteChildren {
  AuthenticatedShellChatIdRoute: typeof AuthenticatedShellChatIdRoute
}

const AuthenticatedShellChatRouteChildren: AuthenticatedShellChatRouteChildren =
  {
    AuthenticatedShellChatIdRoute: AuthenticatedShellChatIdRoute,
  }

const AuthenticatedShellChatRouteWithChildren =
  AuthenticatedShellChatRoute._addFileChildren(
    AuthenticatedShellChatRouteChildren,
  )

interface AuthenticatedShellRouteChildren {
  AuthenticatedShellSplatRoute: typeof AuthenticatedShellSplatRoute
  AuthenticatedShellOwnAccountRoute: typeof AuthenticatedShellOwnAccountRouteWithChildren
  AuthenticatedShellAccountRoute: typeof AuthenticatedShellAccountRoute
  AuthenticatedShellAdminRoute: typeof AuthenticatedShellAdminRouteWithChildren
  AuthenticatedShellAvailabilityRoute: typeof AuthenticatedShellAvailabilityRoute
  AuthenticatedShellBetaRoute: typeof AuthenticatedShellBetaRoute
  AuthenticatedShellBillingRoute: typeof AuthenticatedShellBillingRoute
  AuthenticatedShellChatRoute: typeof AuthenticatedShellChatRouteWithChildren
  AuthenticatedShellContactsRoute: typeof AuthenticatedShellContactsRoute
  AuthenticatedShellMemoriesRoute: typeof AuthenticatedShellMemoriesRoute
  AuthenticatedShellNotificationsRoute: typeof AuthenticatedShellNotificationsRoute
  AuthenticatedShellPersonalChatRoute: typeof AuthenticatedShellPersonalChatRoute
  AuthenticatedShellPlacesRoute: typeof AuthenticatedShellPlacesRoute
  AuthenticatedShellPreferencesRoute: typeof AuthenticatedShellPreferencesRoute
  AuthenticatedShellRecurringRoute: typeof AuthenticatedShellRecurringRoute
  AuthenticatedShellIndexRoute: typeof AuthenticatedShellIndexRoute
  AuthenticatedShellTemplatesIndexRoute: typeof AuthenticatedShellTemplatesIndexRoute
  AuthenticatedShellTemplatesIdEditRoute: typeof AuthenticatedShellTemplatesIdEditRoute
}

const AuthenticatedShellRouteChildren: AuthenticatedShellRouteChildren = {
  AuthenticatedShellSplatRoute: AuthenticatedShellSplatRoute,
  AuthenticatedShellOwnAccountRoute:
    AuthenticatedShellOwnAccountRouteWithChildren,
  AuthenticatedShellAccountRoute: AuthenticatedShellAccountRoute,
  AuthenticatedShellAdminRoute: AuthenticatedShellAdminRouteWithChildren,
  AuthenticatedShellAvailabilityRoute: AuthenticatedShellAvailabilityRoute,
  AuthenticatedShellBetaRoute: AuthenticatedShellBetaRoute,
  AuthenticatedShellBillingRoute: AuthenticatedShellBillingRoute,
  AuthenticatedShellChatRoute: AuthenticatedShellChatRouteWithChildren,
  AuthenticatedShellContactsRoute: AuthenticatedShellContactsRoute,
  AuthenticatedShellMemoriesRoute: AuthenticatedShellMemoriesRoute,
  AuthenticatedShellNotificationsRoute: AuthenticatedShellNotificationsRoute,
  AuthenticatedShellPersonalChatRoute: AuthenticatedShellPersonalChatRoute,
  AuthenticatedShellPlacesRoute: AuthenticatedShellPlacesRoute,
  AuthenticatedShellPreferencesRoute: AuthenticatedShellPreferencesRoute,
  AuthenticatedShellRecurringRoute: AuthenticatedShellRecurringRoute,
  AuthenticatedShellIndexRoute: AuthenticatedShellIndexRoute,
  AuthenticatedShellTemplatesIndexRoute: AuthenticatedShellTemplatesIndexRoute,
  AuthenticatedShellTemplatesIdEditRoute:
    AuthenticatedShellTemplatesIdEditRoute,
}

const AuthenticatedShellRouteWithChildren =
  AuthenticatedShellRoute._addFileChildren(AuthenticatedShellRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedShellRoute: typeof AuthenticatedShellRouteWithChildren
  AuthenticatedInviteDelegateRoute: typeof AuthenticatedInviteDelegateRoute
  AuthenticatedOnboardingSplatRoute: typeof AuthenticatedOnboardingSplatRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedShellRoute: AuthenticatedShellRouteWithChildren,
  AuthenticatedInviteDelegateRoute: AuthenticatedInviteDelegateRoute,
  AuthenticatedOnboardingSplatRoute: AuthenticatedOnboardingSplatRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CustomDomainTestRoute: CustomDomainTestRoute,
  GoogleoauthRoute: GoogleoauthRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  MicrosoftoauthRoute: MicrosoftoauthRoute,
  SignupRoute: SignupRoute,
  SlackoauthRoute: SlackoauthRoute,
  SsoLoginRoute: SsoLoginRoute,
  SsoSignupRoute: SsoSignupRoute,
  WaitlistRoute: WaitlistRoute,
  BookDemoSignUpRoute: BookDemoSignUpRoute,
  McpConsentRoute: McpConsentRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  ZoomCallbackRoute: ZoomCallbackRoute,
  BookDemoIndexRoute: BookDemoIndexRoute,
  LinkNamespaceLinkIdChar123MeetingIdChar125Route:
    LinkNamespaceLinkIdChar123MeetingIdChar125Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
